import { http } from './http';

type ApiOptions = {
  params?: Record<string, any>;
  headers?: HeadersInit;
};

const resolveGetOptions = (options?: ApiOptions | Record<string, any>): ApiOptions => {
  if (!options) {
    return {};
  }

  if ('params' in options || 'headers' in options) {
    return options as ApiOptions;
  }

  return { params: options };
};

export const apiClient = {
  get: <T>(url: string, options?: ApiOptions | Record<string, any>) => {
    const resolved = resolveGetOptions(options);

    return http
      .get(url, {
        searchParams: resolved.params,
        headers: resolved.headers,
      })
      .json<T>();
  },

  post: <T>(url: string, body?: unknown, options?: ApiOptions) =>
    http
      .post(url, {
        json: body,
        headers: options?.headers,
      })
      .json<T>(),

  postForm: <T>(url: string, formData: FormData, options?: ApiOptions) =>
    http
      .post(url, {
        formData,
        headers: options?.headers,
      })
      .json<T>(),

  put: <T>(url: string, body?: unknown, options?: ApiOptions) =>
    http
      .put(url, {
        json: body,
        headers: options?.headers,
      })
      .json<T>(),

  patch: <T>(url: string, body?: unknown, options?: ApiOptions) =>
    http
      .patch(url, {
        json: body,
        headers: options?.headers,
      })
      .json<T>(),

  delete: <T>(url: string, options?: ApiOptions) =>
    http
      .delete(url, {
        headers: options?.headers,
      })
      .json<T>(),
};
